export default __webpack_public_path__ + "static/CBX-Mapa-Parking-MAY2023-solo-nombres-ENG-f9851b4f653d309c7293c8d8f78b038b.png";